// Centralized logging utility
// Debug logs are disabled in production unless REACT_APP_DEBUG=true.

const isDevelopment = process.env.NODE_ENV === "development";
const debugEnabled = process.env.REACT_APP_DEBUG === "true";

const logger = {
  log: (...args) => {
    if (isDevelopment || debugEnabled) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isDevelopment || debugEnabled) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment || debugEnabled) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment || debugEnabled) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};

export default logger;
